import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    Squares2X2Icon,
    WrenchIcon,
    DocumentTextIcon,
    EnvelopeIcon,
    PhotoIcon,
    UsersIcon,
    ArrowLeftOnRectangleIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo.png';
import './AdminSidebar.css';

const AdminSidebar = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/admin/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const menuItems = [
        { path: '/admin', label: 'نظرة عامة', icon: Squares2X2Icon, exact: true },
        { path: '/admin/services', label: 'الخدمات', icon: WrenchIcon },
        { path: '/admin/about', label: 'من نحن', icon: DocumentTextIcon },
        { path: '/admin/inquiries', label: 'الاستفسارات', icon: EnvelopeIcon },
        { path: '/admin/hero', label: 'الواجهة الرئيسية', icon: PhotoIcon },
        { path: '/admin/clients', label: 'العملاء', icon: UsersIcon },
    ];

    return (
        <aside className="admin-sidebar">
            <div className="sidebar-logo">
                <img src={logo} alt="SIGMA Elevators" className="logo-image" />
                <span className="logo-badge">Admin</span>
            </div>

            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end={item.exact}
                        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    >
                        <item.icon className="nav-icon" />
                        <span>{item.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="sidebar-footer">
                <button onClick={handleLogout} className="logout-btn">
                    <ArrowLeftOnRectangleIcon className="nav-icon" />
                    <span>تسجيل الخروج</span>
                </button>
            </div>
        </aside>
    );
};

export default AdminSidebar;
